import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bb8199c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "d-flex flex-column align-items-center p-4 bg-light h-100 sidebar",
  style: {"width":"200px"}
}
const _hoisted_2 = {
  class: "d-flex align-items-center justify-content-center mb-md-0 me-md-auto link-dark text-decoration-none",
  style: {"width":"100%"}
}
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "w-100" }, null, -1))
const _hoisted_5 = { class: "nav nav-pills flex-column justify-content-start align-items-start gap-4 pt-4 no-bullets" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-grid-1x2",
  width: "16",
  height: "16"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-clipboard-plus",
  width: "16",
  height: "16"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-box-arrow-up-right",
  width: "16",
  height: "16"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-toggles",
  width: "16",
  height: "16"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: require('@/assets/lotmaster-high-resolution-logo-color-on-transparent-background (1).png'),
        alt: "logo",
        class: "logo",
        width: "200",
        height: "35"
      }, null, 8, _hoisted_3)
    ]),
    _hoisted_4,
    _createElementVNode("ul", _hoisted_5, [
      _createElementVNode("li", {
        class: _normalizeClass(["nav-item d-flex justify-content-center align-items-center custom-li", { 'active': _ctx.activeLink === 'dashboard' }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeLink = 'dashboard'))
      }, [
        _hoisted_6,
        _createVNode(_component_router_link, {
          to: "/",
          class: "custom-link text-decoration-none"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Dashboard")
          ]),
          _: 1
        })
      ], 2),
      _createElementVNode("li", {
        class: _normalizeClass(["nav-item d-flex justify-content-center align-items-center custom-li", { 'active': _ctx.activeLink === 'register' }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeLink = 'register'))
      }, [
        _hoisted_7,
        _createVNode(_component_router_link, {
          to: "/register",
          class: "custom-link text-decoration-none"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Register")
          ]),
          _: 1
        })
      ], 2),
      _createElementVNode("li", {
        class: _normalizeClass(["nav-item d-flex justify-content-center align-items-center custom-li", { 'active': _ctx.activeLink === 'access' }]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeLink = 'access'))
      }, [
        _hoisted_8,
        _createVNode(_component_router_link, {
          to: "/access",
          class: "custom-link text-decoration-none"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Access")
          ]),
          _: 1
        })
      ], 2),
      _createElementVNode("li", {
        class: _normalizeClass(["nav-item d-flex justify-content-center align-items-center custom-li", { 'active': _ctx.activeLink === 'controle' }]),
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeLink = 'controle'))
      }, [
        _hoisted_9,
        _createVNode(_component_router_link, {
          to: "/controle",
          class: "custom-link text-decoration-none"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Controle")
          ]),
          _: 1
        })
      ], 2)
    ]),
    _hoisted_10
  ]))
}